import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'my_brands-insights_card-click';
/**
 * This is the Insights Card Click event.

These are the following params
1. Origin (i.e brand-page, my-brands-page, etc)
2. Item clicked (i.e brand name, product image)
3. token (brand token, product token)
*/ export function trackMyBrandsInsightsCardClick(customParameterToken, customParameterToken2, customParameterToken3) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            customParameterToken: customParameterToken,
            customParameterToken2: customParameterToken2,
            customParameterToken3: customParameterToken3
        }
    });
}
